import formButton from '@/components/common/form-button/form-button.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    formButton
  },
  props: {
    mode: {
      type: String,
      required: true
    },
    tag: {
      type: Object,
      default: {}
    }
  },
  methods: {
    ...mapActions('tag', ['getTags', 'updateTag', 'deleteTag']),
    onCreateEditTag: async function () {
      try {
        await this.$validator.validate()
        if (this.errors.items.length === 0) {
          this.$emit('onCreateEditTag', this.tag)
        }
        // eslint-disable-next-line no-empty
      } catch (e) {}
    },
    onSaveTag: async function () {
      try {
        await this.$validator.validate()
        if (this.errors.items.length === 0) {
          await this.updateTag(this.tag)
          this.$notify({
            text: 'Tag successfully updated',
            type: 'success'
          })
          this.toggleChildRow()
          this.getTags()
        }
      } catch (e) {
        this.$notify({
          text: 'Error while updating tag',
          type: 'error'
        })
      }
    },
    onDeleteTag: async function () {
      try {
        await this.$dialog.confirm('Are you sure you want to delete this tag?')
        await this.deleteTag({ id: this.tag.id })
        this.$notify({
          text: 'Tag successfully deleted',
          type: 'success'
        })
      } catch (e) {
        this.$notify({
          text: 'Error while deleting tag',
          type: 'error'
        })
      }
    },
    toggleChildRow: function () {
      this.tag.edit(this.tag.id)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/main-pages/settings/tags/tag-add-edit-content/tag-add-edit-content.js